var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgButtonLeftBottomreact = function SvgButtonLeftBottomreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 130 151.628"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1549",
    fill: "#fa6e00"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 52856",
    d: "M130 40.493A47.55 47.55 0 0 1 43.952-.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 52857",
    d: "M110.264 82.433a47.55 47.55 0 0 1-86.049-40.494Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 52858",
    d: "M90.527 124.372A47.55 47.55 0 1 1 4.479 83.877Z"
  }))));
};

export default SvgButtonLeftBottomreact;